import { encodeDelimitedArray, decodeDelimitedArray } from 'use-query-params';

export const CommaArrayParam = {
  encode: (array) => encodeDelimitedArray(array, ','),
  decode: (arrayStr) => decodeDelimitedArray(arrayStr, ','),
};
